export default "/images/4e59ee69ecb4ab95548e1c905a2e2056.avif";